<div class="periods-table-wrapper" data-cy="periods-table-wrapper">

  <app-periods-info-chart
    (openLineIdentifier)="openLine($event, true, true)"
    (hoverLineIdentifier)="mouseHoverLine($event)"
    [selectedLineIdentifier]="openSelectedLineIdentifier"
    [selectedLineMouseHoverIdentifier]="state.isMouseHoverLine"
  [infoChartDataConfiguration]="infoChartData"></app-periods-info-chart>

  <p class="periods-table-title" data-cy="periods-table-title">{{ periodsListTitle }}</p>
  <app-table (selectedLine)="openLine($safeNavigationMigration($event?.identifier))"
    (mouseHoverOpenLine)="mouseHoverLineHandler($event)"
    (mouseHoverLine)="mouseHoverHandler($event)"
    (mouseleave)="mouseHoverHandler($event)"
    [accordionLineTemplate]="accordionLineTemplate"
    [tableData]="tableData"
  [tableName]="TABLE_NAME"></app-table>
</div>

@if (spinnerObservable | async) {
  <div class="spinner-container">
    <app-loading-spinner class="center-spinner"></app-loading-spinner>
  </div>
}

<ng-template #timePeriodTemplate
  let-periodType="periodType"
  let-showInputDate="showInputDate"
  let-timePeriodCode="timePeriodCode"
  let-timePeriodEndDate="timePeriodEndDate"
  let-timePeriodStartDate="timePeriodStartDate"
  let-periodChangedBy="periodChangedBy"
  let-periodChangedOn="periodChangedOn">
  @if (timePeriodCode != null) {
    <div class="periods-table-time-period periods-table-text" data-cy="periods-table-time-period">
      <span class="periods-table-text text-section bold"
      data-cy="periods-table-time-period-text-from">From:</span>
      <div class="periods-table-text view-date-input text-section">
                <ng-container *ngTemplateOutlet="viewInputDateMode;
                   context: {timePeriod: timePeriodStartDate, periodCode: timePeriodCode}"></ng-container>
      </div>
      <span class="periods-table-text text-section bold" data-cy="periods-table-time-period-text-to">to:</span>
            <ng-container *ngTemplateOutlet="showInputDate ? editInputDateMode : viewInputDateMode;
                    context: { timePeriodStartDate: timePeriodStartDate, timePeriod: timePeriodEndDate, periodType: periodType, timePeriodCode: timePeriodCode}"></ng-container>
      @if (isFlyingMenuVisible(periodChangedOn, periodChangedBy)) {
        <ng-template
        *ngTemplateOutlet="periodFlyingMenu;  context: {showInputDate: showInputDate, periodChangedBy: periodChangedBy, periodChangedOn: periodChangedOn}"></ng-template>
      }
    </div>
  } @else {
    <span data-cy="periods-table-undefined-value">-</span>
  }
</ng-template>

<ng-template #editInputDateMode
  let-periodType="periodType"
  let-timePeriod="timePeriod"
  let-timePeriodCode="timePeriodCode"
  let-timePeriodStartDate="timePeriodStartDate">
  <div (click)="clickOnLineComponent($event)" class="view-date-input-edit-mode">
    <app-input-datepicker #editInputDate
      (inputStateChange)="manageRequestedDateInputStateChange($event)"
      (closedDatepicker)="changePeriodTime(timePeriodCode, $event)"
      [alternateBackground]="true"
      [animationStyle]="animationInputDateStyle(timePeriodCode)"
      [displayMonths]="2"
      [initialValue]="datepickerHelperService.convertTimestampTimeZoneToNgbDate(bundlesConfigService.timezone, timePeriod)"
      [isDisabledCalendarButton]="isDisabledCalendarButton(timePeriodStartDate)"
      [minDate]="setMinDate(timePeriodStartDate, periodType)"
      [timezone]="bundlesConfigService.timezone"
      [validators]="validators.requestedDate"
      [isDisabled]="hasBundlePeriodManagePermission"
      baseCypressTag="periods-table-time-period-text-to-value">
    </app-input-datepicker>
  </div>
</ng-template>

<ng-template #viewInputDateMode let-periodCode="periodCode" let-timePeriod="timePeriod">
  <div class="view-date-input text-section">
    <app-input-date
      [animationStyle]="animationInputDateStyle(periodCode, true)"
      [initialValue]="timePeriod"
      [showViewMode]="true"
      [timezone]="bundlesConfigService.timezone"
      baseCypressTag="periods-table-time-period-text-from-value">
    </app-input-date>
  </div>
</ng-template>

<ng-template #periodTypeTemplate
  let-periodType="periodType"
  let-periodTypeIndex="periodTypeIndex">
  @if (periodType != null) {
    <div class="period-type-content-section">
      <div class="period-type-content-wrapper">
        <div class="period-type-dot-wrapper">
          <div [ngClass]="periodType.code" class="period-type-dot" data-cy="period-type-dot"></div>
          @if (managePeriodTypeDotLineTop(periodTypeIndex)) {
            <div
              class="period-type-dot-line top"
            data-cy="period-type-dot-line-top"></div>
          }
          @if (managePeriodTypeDotLineBottom(periodTypeIndex)) {
            <div
              class="period-type-dot-line bottom"
            data-cy="period-type-dot-line-bottom"></div>
          }
        </div>
        <div [ngClass]="{'line-open': isLineOpen(periodTypeIndex), 'line-hover': isLineOpenAndHover(periodTypeIndex) }"
        class="period-type-empty-border"></div>
      </div>
      <div class="period-type-text-wrapper">
        <app-tooltip [message]="periodType.name">
          <span class="periods-table-text text-section bold"
          data-cy="periods-table-period-type-text">{{periodType.name}}</span>
        </app-tooltip>
      </div>
    </div>
  } @else {
    <span data-cy="periods-table-undefined-value">-</span>
  }
</ng-template>

<ng-template #bundlesStatusTemplate let-bundlesStatusData="bundlesStatusData">
  <div class="bundles-status-wrapper" data-cy="bundles-status-wrapper">
    @for (bundlesStatus of bundlesStatusData; track bundlesStatus) {
      <div class="bundles-status-content">
        <div class="bundles-status-content-count" data-cy="bundles-status-content-count"
          [ngClass]="bundlesStatus.type"
        [ngStyle]="getBundlesStatusFontSize(bundlesStatus.count)">{{bundlesStatus.count}}</div>
        <div class="bundles-status-content-label" data-cy="bundles-status-content-label">{{bundlesStatus.label}}</div>
      </div>
    }
  </div>
</ng-template>

<ng-template #periodFlyingMenu
  let-showInputDate="showInputDate">
  <div class="period-user-wrapper"
    [ngClass]="showInputDate ? 'period-user-wrapper-with-input' : 'period-user-wrapper-without-input'">
    <app-tooltip [dynamic]="false"
      tooltipCustomClass="auto-close-bundles-section-tooltip-width"
      [message]="autoCloseTooltip"><i data-cy="period-user-icon" class="period-user iwp-icon-gen_user"></i>
    </app-tooltip>
  </div>
</ng-template>


<ng-template #accordionLineTemplate>
  <app-period-bundles-table [periodDetail]="accordionContext"
  (updatePeriodDetailValue)="updatePeriodValues($event)"></app-period-bundles-table>
</ng-template>

<ng-template #autoCloseTooltip>
  <b data-cy="period-user-tooltip-detail-label">{{PERIOD_CREATED_BY_LABEL}}</b>
  <div style="margin-bottom: 6px"></div>
  <p data-cy="period-user-tooltip-detail-content">{{getLastChangedByMouseHoverLine() | prettyPrintClosedBy | undefinedValue}}</p>
  <div style="margin-bottom: 24px"></div>
  <b data-cy="period-user-tooltip-detail-created-on-label">{{PERIOD_CREATED_ON_LABEL}}</b>
  <div style="margin-bottom: 6px"></div>
  <p data-cy="period-user-tooltip-detail-created-on-content">{{periodSentOn(getLastChangedOnMouseHoverLine())| undefinedValue}}</p>
</ng-template>
